import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { logger } from '@fiverr-private/obs';
import { ConfigResponse, FetchedOrganizationPackagesData } from '../types';

export const queryOrganizationSellerData = async () =>
    axios.post(pathfinder('query_organization_seller_data_by_ids'), {}, { timeout: 1000 });

export const getSellerComplianceConfigData = async ({ sellerId }: { sellerId: number }): Promise<ConfigResponse> => {
    const url = pathfinder('compliance_configs_by_requestor_and_requestee_ids', {
        requestee_id: sellerId,
    });
    try {
        const response = await axios.get<ConfigResponse>(url);
        return response.data;
    } catch (error) {
        logger.warn(error as Error, {
            description: `Failed to get config data for requeseteeId - ${sellerId}], route: [${url}]`,
        });

        throw error;
    }
};

export const getOrganizationPackagesData = async (): Promise<FetchedOrganizationPackagesData> => {
    const url = pathfinder('compliance_packages_data_by_organization_id');
    try {
        const response = await axios.get<FetchedOrganizationPackagesData>(url);
        return response.data;
    } catch (error) {
        logger.warn(error as Error, {
            description: `Failed to get organization packages data, route: [${url}]`,
        });

        throw error;
    }
};

export const getOrganizationComplianceData = async (organizationId?: string, sellerIds?: number[]) => {
    if (!organizationId) return {};
    const url = pathfinder('query_organization_seller_data_by_ids');
    try {
        const response = await axios.post(url, {
            sellerIds: sellerIds || [],
        });
        return response.data;
    } catch (error) {
        logger.error(error as Error, {
            description: `Failed to get compliance data for : [organizationId - ${organizationId}], route: [${url}]`,
        });

        throw error;
    }
};
